import UserPartnerAccountsPanel from './UserPartnerAccountsPanel';

export default UserPartnerAccountsPanel;
